import { useCallback } from 'react';

import type { Account } from '../../../generated-types';
import { useFormContext as useDefaultFormContext, Form } from '../../../hooks/useForm';
import { PaymentActionType } from '../Payment/form/actions';
import useFormContext from '../Payment/form/useFormContext';
import { TransferAction, TransferActionType } from '../Transfer/form/actions';
import { TransferState } from '../Transfer/form/state';
import { TransferError } from '../Transfer/form/validate';

const useTransferFormContext = useDefaultFormContext as () => Form<
    TransferState,
    TransferAction,
    TransferError,
    TransferActionType
>;

const getFormBasedOnType = (transactionType: 'payment' | 'transfer') => {
    return {
        hook: transactionType === 'payment' ? useFormContext : useTransferFormContext,
        type: transactionType === 'payment' ? PaymentActionType : TransferActionType,
    };
};
export default (transactionType: 'payment' | 'transfer', onClose: () => void, account: Account | undefined) => {
    const { hook, type } = getFormBasedOnType(transactionType);
    const { handleChange } = hook();

    const resetForm = useCallback(() => {
        (handleChange as (action: unknown) => void)({
            type: type.RESET_WITH_FROM_ACCOUNT,
            payload: account?.accountNumber,
        });
    }, [account, handleChange, type]);
    const resetFormAndClose = useCallback(() => {
        resetForm();
        onClose();
    }, [resetForm, onClose]);

    return {
        resetForm,
        resetFormAndClose,
    };
};
